<template>
    <div>
        <h1>I am guest page</h1>
    </div>
</template>
<script>
export default {
    
}
</script>